import {Panes, TextField} from '@management-ui/core';
import React from 'react';

const Fields = ({template = {}, prefix = '', multiplePanes = true, children}) => {
  return (
    <Panes
      entity={template}
      prefix={prefix}
      panes={[
        {
          title: 'Template Details',
          fields: [
            <TextField
              name="name"
              prefix={prefix}
              label="Name"
              rules={{required: 'Please enter a name for this template'}}
            />,
            <TextField
              name="title"
              prefix={prefix}
              label="Title"
            />,
          ]
        },
        {
          title: 'Job Details',
          fields: [
            <TextField
              name="description"
              prefix={prefix}
              label="Description"
              fieldProps={{multiline: true, rows: 5}}
            />,
          ]
        }
      ]}
      title={multiplePanes ? null : 'Details'}
    >{children}</Panes>
  );
};

export default Fields;
